//Create and store a GUID used to identify anonymous users between sessions.
export const getSentryAnonymousUserGuid = () => {
    try {
        // Retrieve stored GUID.
        const storedUserId = localStorage.getItem("sentry-user-id");
      

        if (storedUserId) {
            // return stored GUID
            return storedUserId;
        }

        // Create new GUID as no stored GUID exsits.

        const userId = crypto.randomUUID();

        // Store new GUID

        localStorage.setItem("sentry-user-id", userId);

        // Return new GUID.

        return userId;
    }
    catch {
        // Local Storage can be disabled or limited by the users browser
        // settings. If local storage is not accessible the above will
        // error and a new GUID will be returned. For these users they will
        // only be able to be identified until they refresh the page.
        return crypto.randomUUID();
    }
}

// Function to return the Anonymous user data.

export const createSentryAnonymousUser = () => {
    const userGuid = getSentryAnonymousUserGuid();

    return {
        id: `Anonymous - ${userGuid}`,
        username: `Anonymous - ${userGuid}`,
        fullName: 'Anonymous User'
    }
}